<template>
  <header class="app-header">
    <AppLogo :is-text-visible="breakpoints.mdAndUp" />
    <ClientOnly>
      <div class="settings">
        <NuxtLink
          rel="nofollow"
          target="_blank"
          :to="mainAppBaseUrl"
          :aria-label="getContent('preview.button_block_button_3')"
        >
          <AppBtn
            width="164"
            rounded="30"
            class="purple-btn"
            :aria-label="getContent('preview.button_block_button_3')"
          >
            <span>
              {{ getContent('preview.button_block_button_3') }}
            </span>
          </AppBtn>
        </NuxtLink>
        <AppHeaderWallet />
      </div>
    </ClientOnly>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data: () => ({
    breakpoints: useBreakpoints(),
  }),
  computed: {
    mainAppBaseUrl () {
      return useRuntimeConfig().public.mainAppBaseUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header {
  top: 32px;
  left: 50%;
  z-index: 10;
  display: flex;
  position: absolute;
  padding: 16px 32px;
  align-items: center;
  border-radius: 48px;
  width: calc(100vw - 64px);
  transform: translateX(-50%);
  justify-content: space-between;
  background-color: $black;

  .settings {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;
  }
}

@media only screen and (max-width: $sm) {
  .app-header {
    top: 16px;
    padding: 16px 20px;
    width: calc(100vw - 32px);

    .settings {
      gap: 16px;
    }
  }
}
</style>
